<template>
  <div>
    <div v-if="prescription && haspres" v-loading="DOWNLOADING_PRESCRIPTION" :element-loading-text="$t('message.Getting your prescription')">
      <div style="position: fixed;bottom:0;z-index:1;width:100%;text-align:center;">
        <n-button type="primary" round @click.native="downloadPrescription(prescription.prescriptions, prescription.created)" v-if="HAS_PRESCRIPTION">
          <i class="fa fa-print"></i>
          {{ $t("message.Download Prescription") }}
        </n-button>
      </div>

      <card style="height:100%; overflow-y: scroll; padding-bottom: 4em; ">
        <prescription :prescription="prescription.prescriptions" v-if="prescription" :editable="false"></prescription>
      </card>
    </div>

  </div>
</template>

<script>
import PrescriptionService from "../../services/prescription.js";

export default {
  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
  },

  data() {
    return {
      prescription: null,
      haspres: false,
      DOWNLOADING_PRESCRIPTION: false,
    };
  },

  methods: {
    downloadPrescription(prescriptions, prescriptionDate) {
      let that = this;
      that.DOWNLOADING_PRESCRIPTION = true;
      if (window.cordova) {
        PrescriptionService.getDataURL(
          this.appointment,
          prescriptions,
          prescriptionDate,
          {},
          (dataUrl) => {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataUrl.split(",")[1]);

            // separate out the mime component
            var mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer
            var ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            var pdfBlob = new Blob([ab], { type: mimeString });

            let storageLocation = "";

            if (typeof device !== "undefined") {
              switch (device.platform) {
                case "Android":
                  storageLocation = cordova.file.externalDataDirectory;
                  break;

                case "iOS":
                  storageLocation = cordova.file.documentsDirectory;
                  break;
              }

              let folderPath = storageLocation;

              window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                  dir.getFile(
                    "prescription",
                    {
                      create: true,
                    },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(pdfBlob);

                          fileWriter.onwriteend = function () {
                            var url = file.nativeURL;
                            cordova.plugins.fileOpener2.open(
                              url,
                              pdfBlob.type,
                              {
                                error: function error(err) {
                                  console.error(err);
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  alert(this.$t("message.Unable to download"));
                                },
                                success: function success() {
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  console.log("success with opening the file");
                                },
                              }
                            );
                          };

                          fileWriter.onerror = function (err) {
                            that.DOWNLOADING_PRESCRIPTION = false;
                            alert(this.$t("message.Unable to download"));
                            console.error(err);
                          };
                        },
                        function (err) {
                          that.DOWNLOADING_PRESCRIPTION = false;
                          // failed
                          alert(this.$t("message.Unable to download"));
                          console.error(err);
                        }
                      );
                    },
                    function (err) {
                      that.DOWNLOADING_PRESCRIPTION = false;
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.DOWNLOADING_PRESCRIPTION = false;
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            }
          }
        );
      } else {
        PrescriptionService.download(
          this.appointment,
          prescriptions,
          prescriptionDate,
          {}
        );
      }
    },
    HAS_PRESCRIPTION() {
      if (this.prescription) {
        let prescriptions = this.prescription.prescriptions;
        return PrescriptionService.hasPrescription(prescriptions);
      }
    },
  },

  async mounted() {
    //get prescription from prescription id
    let prescriptionId = this.$route.params.prescriptionId;
    this.prescription = await this.$store.dispatch("getHistoricPrescription", {
      prescriptionId,
    });
    this.haspres = this.HAS_PRESCRIPTION();
  },
};
</script>

<style></style>
